export class StringUtilities {

  public static truncateText(text:string, maxLength:number){
    let words = text.split(" ");
    let result = "";
    let index = 1;
    result = words[0];
    while(index < words.length && (result+words[index]).length<maxLength){
      result+= " "+ words[index];
      index++;
    }
    return result==text?result:result + " ...";
  }
}



// WEBPACK FOOTER //
// ./src/app/common/string.utilities.ts